import { render, staticRenderFns } from "./Valuation.vue?vue&type=template&id=024ac560&scoped=true&"
import script from "./Valuation.vue?vue&type=script&lang=js&"
export * from "./Valuation.vue?vue&type=script&lang=js&"
import style0 from "./Valuation.vue?vue&type=style&index=0&id=024ac560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ac560",
  null
  
)

export default component.exports